<template>
  <div>
    <router-view></router-view>
    <CSpinner v-if="showSpinner" color="info" class="spinner hidden" />
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  setup() {
    const store = useStore();
    const router = useRoute();
    return { store, router };
  },
  mounted() {
    this.resetLoading();
  },
  computed: {
    showSpinner() {
      // Show the login spinner only if loading and on the login page
      return this.store.state.isLoading && this.store.state.useLoading && this.router.name === 'Login';
    },
  },
  methods: {
    ...mapMutations(['resetLoadingCount']),

    resetLoading() {
      this.resetLoadingCount();
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@use 'assets/scss/style' as styles;

.spinner {
  top: 48%;
  left: 30%;
  position: absolute;
  width: 4rem;
  height: 4rem;
  border-width: 0.65rem;
  opacity: 0.7;
  z-index: 9999;
}
</style>
